module.exports = __webpack_public_path__ + "static/media/undraw_searching_re_3ra9.6067819f.svg";